import { render, staticRenderFns } from "./EachCountryCardDeck.vue?vue&type=template&id=1b22cc2e&scoped=true&"
import script from "./EachCountryCardDeck.vue?vue&type=script&lang=js&"
export * from "./EachCountryCardDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22cc2e",
  null
  
)

export default component.exports